import type { ProjectRole, UserRole } from '../types/api'

// Mirrors the backend `hasAdminPrivileges` (backend/api/authz/access.ts): a
// platform superadmin is a strict superset of an org admin, so every
// admin-gated control must treat `superadmin` the same as `admin`.
export function isGlobalAdmin(role: UserRole | undefined): boolean {
  return role === 'admin' || role === 'superadmin'
}

export function canManageProject(projectRole: ProjectRole | undefined): boolean {
  return projectRole === 'admin' || projectRole === 'manager'
}

export function projectRoleLabel(projectRole: ProjectRole | undefined): string {
  switch (projectRole) {
    case 'admin':
      return 'Admin'
    case 'manager':
      return 'Manager'
    case 'viewer':
      return 'Viewer'
    default:
      return 'Member'
  }
}
